import axios from "../axios";
import { bannerCardsURL } from "../requests";

export const getBannerCardsApi = (token) => {
  return axios.get(bannerCardsURL, {
    headers: { token },
    baseURL: process.env.REACT_APP_DASHBOARD_ENDPOINT,
  });
};
